import { connect } from 'react-redux';
import { changeInforEditOrder, changeEditOrder } from './../../../../../actions/editOrder';
import ShipmentRemarkComponent from './../../../components/shipment-remark';
import './styles.css';

class ShipmentRemark extends ShipmentRemarkComponent { }

const mapStateToProps = state => {
    return {
        classes: state.editOrder.classes,
        information: state.editOrder.information,
        shipperInformation: state.editOrder.shipperInformation,
        order: state.editOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(changeInforEditOrder(payload))
        },
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentRemark)



// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/shipment-remark/index.js